import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-25649294"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  class: "container-fluid"
};
const _hoisted_3 = {
  class: "navbar-brand",
  href: "/index.html"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "navbar-toggler-icon"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  "aria-current": "page",
  href: "/index.html"
}, "首页", -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " 智能体 ", -1));
const _hoisted_10 = {
  class: "dropdown-menu"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, " 安全工具型智能体 ", -1));
const _hoisted_12 = {
  class: "dropdown-menu dropdown-submenu"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/codeProduct.html"
}, " 无垠模糊测试智能体 ", -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/sastProduct.html"
}, " 无暇软件缺陷分析智能体 ", -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/codeSafety.html"
}, " 代码安全类智能体 ", -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/safetyKnowledgeProduct.html"
}, " 安全知识类智能体 ", -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/aigcProduct.html"
}, " 云起AI安全大脑 ", -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/modelTraining.html"
}, " 模型定制化训练框架 ", -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " 安全服务 ", -1));
const _hoisted_26 = {
  class: "dropdown-menu"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/fuzzTest.html"
}, " 模糊测试服务 ", -1));
const _hoisted_28 = [_hoisted_27];
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/safetyTest.html"
}, " 安全测试服务 ", -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/confrontationTest.html"
}, " 红蓝对抗服务 ", -1));
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/nourishTest.html"
}, " 人才培养服务 ", -1));
const _hoisted_34 = [_hoisted_33];
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/competitionTest.html"
}, " 竞赛服务 ", -1));
const _hoisted_36 = [_hoisted_35];
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  "aria-current": "page",
  href: "/corporateBlog.html"
}, "企业博客", -1));
const _hoisted_38 = [_hoisted_37];
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  href: "/cooperatePage.html"
}, "商务合作", -1));
const _hoisted_40 = [_hoisted_39];
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nav-link",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " 关于我们 ", -1));
const _hoisted_42 = {
  class: "dropdown-menu"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/aboutUs.html?type=1"
}, " 企业介绍 ", -1));
const _hoisted_44 = [_hoisted_43];
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/aboutUs.html?type=2"
}, " 加入我们 ", -1));
const _hoisted_46 = [_hoisted_45];
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "/aboutUs.html?type=3"
}, " 联系我们 ", -1));
const _hoisted_48 = [_hoisted_47];
const _hoisted_49 = {
  key: 1,
  class: "right-phone"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "header-dom",
    style: _normalizeStyle(_ctx.scrollTop !== 0 ? 'background-color: rgba(1, 13, 40, 1);' : '')
  }, [_createElementVNode("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", _hoisted_3, [_createElementVNode("img", {
    src: require('@/assets/img/header/header-logo.png'),
    alt: "云起无垠",
    class: "header-logo"
  }, null, 8, _hoisted_4)]), _createElementVNode("button", {
    class: "navbar-toggler",
    type: "button",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.showMenu && _ctx.showMenu(...args))
  }, _hoisted_6), _ctx.headerType !== 'demo' ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(_ctx.isShowMenu ? 'navbar-nav-mobile' : 'navbar-nav')
  }, [_createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 0 ? 'nav-item active' : 'nav-item')
  }, _hoisted_8, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.1 || _ctx.activeNum === 1.2 || _ctx.activeNum === 1.3 || _ctx.activeNum === 1.4 || _ctx.activeNum === 1.5 || _ctx.activeNum === 1.6 || _ctx.activeNum === 1.7 ? 'nav-item active' : 'nav-item')
  }, [_hoisted_9, _createElementVNode("ul", _hoisted_10, [_createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.1 || _ctx.activeNum === 1.2 ? 'sub-select active' : 'sub-select')
  }, [_hoisted_11, _createElementVNode("ul", _hoisted_12, [_createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.1 ? 'active' : '')
  }, _hoisted_14, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.2 ? 'active' : '')
  }, _hoisted_16, 2)])], 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.5 ? 'active' : '')
  }, _hoisted_18, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.4 ? 'active' : '')
  }, _hoisted_20, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.6 ? 'active' : '')
  }, _hoisted_22, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 1.7 ? 'active' : '')
  }, _hoisted_24, 2)])], 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 5.1 || _ctx.activeNum === 5.2 || _ctx.activeNum === 5.3 || _ctx.activeNum === 5.4 || _ctx.activeNum === 5.5 ? 'nav-item active' : 'nav-item')
  }, [_hoisted_25, _createElementVNode("ul", _hoisted_26, [_createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 5.1 ? 'active' : '')
  }, _hoisted_28, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 5.2 ? 'active' : '')
  }, _hoisted_30, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 5.3 ? 'active' : '')
  }, _hoisted_32, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 5.4 ? 'active' : '')
  }, _hoisted_34, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 5.5 ? 'active' : '')
  }, _hoisted_36, 2)])], 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 2.1 || _ctx.activeNum === 2.2 ? 'nav-item active' : 'nav-item')
  }, _hoisted_38, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 3 ? 'nav-item active' : 'nav-item')
  }, _hoisted_40, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 4.1 || _ctx.activeNum === 4.2 || _ctx.activeNum === 4.3 ? 'nav-item active' : 'nav-item')
  }, [_hoisted_41, _createElementVNode("ul", _hoisted_42, [_createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 4.1 ? 'active' : '')
  }, _hoisted_44, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 4.2 ? 'active' : '')
  }, _hoisted_46, 2), _createElementVNode("li", {
    class: _normalizeClass(_ctx.activeNum === 4.3 ? 'active' : '')
  }, _hoisted_48, 2)])], 2)], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_49, [_hoisted_50, _createTextVNode("咨询服务热线：010-58171400 ")]))])])], 4);
}